import { FormControl, FormHelperText, InputLabel, OutlinedInput } from '@mui/material';
import React, { forwardRef, useImperativeHandle } from 'react';
import { useForm } from 'react-hook-form';
// Требования совпадают с серверной политикой (Nest, password-policy):
// длину и regex берём из config, текст ошибки сервера показываем как есть.
const PASSWORD_HELPER = `Не короче ${config.passwordPolicyLength} символов: заглавная и строчная буквы и цифра`;
const ChangePasswordForm = forwardRef(function (props, ref) {
    const { onSubmit } = props;
    const { register, handleSubmit, formState, getValues } = useForm({
        defaultValues: {
            password: '',
            confirmPassword: '',
        },
    });
    useImperativeHandle(ref, () => ({
        handleSubmitForm: () => {
            handleSubmit((data) => onSubmit({
                password: data.password,
            }))();
        },
    }));
    return (React.createElement("form", null,
        React.createElement(FormControl, { error: !!formState.errors.password, margin: 'normal', variant: 'outlined', fullWidth: true },
            React.createElement(InputLabel, null, "\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C"),
            React.createElement(OutlinedInput, Object.assign({ label: '\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C', type: 'password', fullWidth: true, placeholder: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C', autoComplete: 'new-password', autoFocus: true }, register('password', {
                required: true,
                pattern: config.passwordPolicyPattern,
            }))),
            React.createElement(FormHelperText, null, PASSWORD_HELPER)),
        React.createElement(FormControl, { error: !!formState.errors.confirmPassword, margin: 'normal', variant: 'outlined', fullWidth: true },
            React.createElement(InputLabel, null, "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C"),
            React.createElement(OutlinedInput, Object.assign({ label: '\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C', type: 'password', fullWidth: true, placeholder: '\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C', autoComplete: 'new-password' }, register('confirmPassword', {
                required: true,
                validate: (value) => value === getValues('password') || 'Пароли не совпадают',
            }))),
            React.createElement(FormHelperText, null, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C \u0435\u0449\u0451 \u0440\u0430\u0437, \u0447\u0442\u043E\u0431\u044B \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043E\u043F\u0435\u0447\u0430\u0442\u043A\u0443."))));
});
export default ChangePasswordForm;
